// frontend/src/components/dashboard/TodayPlanCard.tsx

import { Link } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';
import { ActiveCourseSummary } from '../../types/dashboard.types';

interface TodayPlanCardProps {
  courses: ActiveCourseSummary[];
}

const SUBJECT_COLORS: Record<string, string> = {
  'gradient-1': 'linear-gradient(135deg, #17C79A, #06B6D4)',
  'gradient-2': 'linear-gradient(135deg, #06B6D4, #3B82F6)',
  'gradient-3': 'linear-gradient(135deg, #D946EF, #8B5CF6)',
};

export function TodayPlanCard({ courses }: TodayPlanCardProps) {
  const planItems = courses.slice(0, 4);

  return (
    <div className="nd-card">
      <div className="nd-card-header">
        <h2 className="nd-card-title">
          <span className="nd-card-title-icon">📚</span>
          Kaldığın Dersler
        </h2>
      </div>
      <div className="nd-plan-list">
        {planItems.length === 0 ? (
          <div className="nd-empty">
            <p>Henüz aktif ders bulunmuyor.</p>
            <Link to="/courses" className="nd-link-btn">Derslere Göz At →</Link>
          </div>
        ) : (
          planItems.map((course) => (
            <Link to={`/courses/${course.id}`} key={course.id} className="nd-plan-item">
              <div className="nd-plan-icon" style={{ background: SUBJECT_COLORS[course.gradient] || 'linear-gradient(135deg, #17C79A, #0EA87F)' }}>
                <span>{course.icon}</span>
              </div>
              <div className="nd-plan-info">
                <span className="nd-plan-name">{course.title}</span>
              </div>
              <span className="nd-plan-duration">%{course.progressPercent}</span>
            </Link>
          ))
        )}
      </div>
      {planItems.length > 0 && (
        <Link to="/courses" className="nd-start-plan-btn">
          <PlayCircle size={18} />
          Derslere Devam Et
        </Link>
      )}
    </div>
  );
}

